export const CATALOG_MODULES = ["commerce_products", "tablee_orders", "catálogo tablee", "catalogo tablee"];
export const INVENTORY_MODULES = ["inventario", "inventory"];
export const PRODUCT_WORKSPACE_MODULES = [...CATALOG_MODULES, ...INVENTORY_MODULES];
